// Imports
import React, { useState } from "react";
import RecNextStepsCards from "../../RecNextStepsCard/jsx/index.jsx";

function RecNextSteps() {
  const nextSteps = window?.config?.nextSteps ?? [];
  const [steps] = useState(nextSteps);
  return steps.length ? (
    <>
      <div className="rec-next-steps">
        <div className="rec-next-steps__header">
          <h2 className="rec-next-steps__heading">Your next steps</h2>
        </div>
        <ul className="rec-next-steps__cards">
          {steps.map((s, index) => (
            <RecNextStepsCards
              key={index}
              nextCardStep={index + 1}
              nextCardTitle={s.split("|")[0]}
              nextCardDesc={s.split("|")[1]}
            />
          ))}
        </ul>
      </div>
    </>
  ) : (
    <div className="rec-next-steps"></div>
  );
}

export default RecNextSteps;
